import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

// Root reducers, EffectsModule.forRoot and StoreDevtools are registered once in RootStoreModule;
// NgRx 9+ throws when forRoot() is called a second time.
@NgModule({
  exports: [StoreModule]
})
export class AppStoreModule { }
